module.exports = __webpack_public_path__ + "img/tjhby.990d7786.png";